var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58003 5.435C4.53003 5.43 4.47003 5.43 4.41503 5.435C3.22503 5.395 2.28003 4.42 2.28003 3.22C2.28003 1.995 3.27003 1 4.50003 1C5.72503 1 6.72003 1.995 6.72003 3.22C6.71503 4.42 5.77003 5.395 4.58003 5.435Z",
    stroke: "#798293",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20501 2C9.17501 2 9.95501 2.785 9.95501 3.75C9.95501 4.695 9.20501 5.465 8.27001 5.5C8.23001 5.495 8.18501 5.495 8.14001 5.5",
    stroke: "#798293",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07999 7.28C0.869985 8.09 0.869985 9.41 2.07999 10.215C3.45499 11.135 5.70999 11.135 7.08499 10.215C8.29499 9.405 8.29499 8.085 7.08499 7.28C5.71499 6.365 3.45999 6.365 2.07999 7.28Z",
    stroke: "#798293",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17004 10C9.53004 9.925 9.87004 9.78 10.15 9.565C10.93 8.98 10.93 8.015 10.15 7.43C9.87504 7.22 9.54004 7.08 9.18504 7",
    stroke: "#798293",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.76baf2f01eca11896169db1222100166.svg";
export { ForwardRef as ReactComponent };